import React from "react";
import BloxIcon from "../icons/BloxIcon.jsx";

/* Hover-revealed contextual action chips for table rows. Wrap the
   parent row with className="term-has-ctx" and place <ItemActions />
   inside; the CSS in terminal.css handles the opacity reveal.

   Usage:
     <div className="term-has-ctx">
       ...row...
       <ItemActions actions={CTX.position("USD")} />
     </div>
*/

export default function ItemActions({ actions = [], onAct }) {
  if (!actions.length) return null;
  return (
    <span className="term-ctx-actions" style={{ marginLeft: "auto" }}>
      {actions.map((a, i) => (
        <button
          key={i}
          type="button"
          title={a.label}
          className="term-ctx-btn"
          style={{ color: a.color || "var(--term-ink-2)" }}
          onClick={(e) => {
            e.stopPropagation();
            if (a.onClick) a.onClick(e);
            else onAct?.(a);
          }}
          onMouseEnter={(e) => {
            const c = a.color || "#4A8CFF";
            e.currentTarget.style.background = c + "22";
            e.currentTarget.style.borderColor = c;
            e.currentTarget.style.color = c;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.borderColor = "var(--term-line)";
            e.currentTarget.style.color = a.color || "var(--term-ink-2)";
          }}
        >
          {a.icon ? <BloxIcon name={a.icon} size={11} stroke={1.5} /> : (
            <span style={{ fontSize: 11, fontWeight: 600 }}>{a.glyph || "•"}</span>
          )}
        </button>
      ))}
    </span>
  );
}

/* Action presets per item type — shared vocabulary across panes.
   Mirrors the prototype's CTX registry so the action surface stays
   consistent when we wire each row to a real handler. */
export const CTX = {
  position: (sym) => [
    { icon: "convert", label: `Convert ${sym}`, color: "#06B6D4" },
    { icon: "deploy",  label: `Deploy ${sym}`,  color: "#A78BFA" },
    { icon: "move",    label: `Move ${sym}`,    color: "#4A8CFF" },
  ],
  counterparty: (name) => [
    { icon: "send",    label: `Pay ${name}`, color: "#4A8CFF" },
    { icon: "receive", label: `Request from ${name}`, color: "#2CCB7E" },
    { icon: "search",  label: "History", color: "var(--term-ink-2)" },
  ],
  activity: (a) => [
    { icon: "search", label: "Inspect payment", color: "var(--term-ink-2)" },
    { icon: "repay",  label: "Re-run", color: "#A78BFA" },
  ],
  corridor: (c) => [
    { icon: "search", label: `Drill ${c.from}→${c.to}`, color: "var(--term-ink-2)" },
    { icon: "send",   label: "New payment on this corridor", color: "#4A8CFF" },
  ],
  payee: () => [
    { icon: "send",     label: "Pay now", color: "#2CCB7E" },
    { icon: "schedule", label: "Schedule", color: "#A78BFA" },
    { icon: "search",   label: "View invoices", color: "var(--term-ink-2)" },
  ],
  channel: () => [
    { icon: "receive", label: "Share link", color: "#2CCB7E" },
    { icon: "search",  label: "Open ledger", color: "var(--term-ink-2)" },
  ],
};
